import { connect } from 'react-redux'
import validator from 'email-validator'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'

import page from 'page'
import classNames from 'classnames'

import timeout from './../helpers/rAF'
import { fetchingState } from './../helpers/hocs.js'
import { subscribe } from './../store/reducers/home'
import { getContacts } from '../store/reducers/contacts'
import { getCountries } from '../store/reducers/countries'
import { logOut, getUserSettings } from '../store/reducers/auth.js'
import { getIsLogged, getSettingsInfo } from '../selectors/user.js'
import {abTestInit} from './../abtest/abtest'
import moment from 'moment'

// Containers


import NotFound from './404'
import Search from './Search'
import Signin from './Signin'



// Components
import Header from './../components/Header'
import Footer from './../components/Footer'
import Menu from './../components/MobileMenu'
import Overlay from './../components/Overlay'
import ChooseRole from '../components/Profile/ChooseRole'
import DynamicBanner from '../components/PersonProfile/DynamicBanner'
import EditForm from './../components/Profile/Edit'
import ClaimForm from './../components/Profile/Claim'
import Region from './../components/Region/Region'
import EmailPopup from './../components/EmailPopup'
import getRoutes, {PERMISSION} from '../helpers/getRoutes.jsx'
import { get, getLots } from '../store/reducers/persons/info'
import { getAllVisits } from '../store/reducers/visitsOfPerson'

const {SITE} = require('../store/middlewares/api.js');

class MainLayout extends Component {
  constructor (props) {
    super(props)

    this.state = {
      removeDelay: false,
      isIndex: true,
      isSignin: false,
      isSearch: false,
      isLight: false,
      isBottomOrange: false,
      isBottomWhite: false,
      isHalfLight: false,
      isMenuOpen: false,
      container: null,
      isOverlap: false,
      isRegion: false,
      isEmailPopup: false,
      isRolePopup: false,
      isFirstEnterPerson: false,
      isNewVisit: false,
      isNewLot: false,
      isFinishedLot: false,
      isNotificate: false,
      registrationLogin: false,

      newLotId: null,
      finishedLotId: null,
      visitId: null,
      agreedVisitId: null,

      isViewed_WelcomeBanner: false,
      isViewed_VisitBanner: false,
      isViewed_LotBanner: false,
      // isViewed_finishedLotBanner: false,
      isViewed_NotificationBanner: false,
    
      notificationDate: Date.now,

      modalState: {}
    }

    this.handle404 = this.handle404.bind(this)
    this.handleCloseSigin = this.handleCloseSigin.bind(this)
    this.handleOpenSigin = this.handleOpenSigin.bind(this)
    this.handleCloseSearch = this.handleCloseSearch.bind(this)
    this.handleCloseRegion = this.handleCloseRegion.bind(this)
    this.handleOpenRegion = this.handleOpenRegion.bind(this)
    this.handleOpenSearch = this.handleOpenSearch.bind(this)
    this.handleMenuOpen = this.handleMenuOpen.bind(this)
    this.handleMenuClose = this.handleMenuClose.bind(this)
    this.handleOpenEmailPopup = this.handleOpenEmailPopup.bind(this)
    this.handleCloseEmailPopup = this.handleCloseEmailPopup.bind(this)
    this.handleOpenCheckRole = this.handleOpenCheckRole.bind(this)
    this.handleCloseCheckRole = this.handleCloseCheckRole.bind(this)
    this.handleCloseEnterPerson = this.handleCloseEnterPerson.bind(this)
    this.handleOpenEnterPerson = this.handleOpenEnterPerson.bind(this)
    this.handleOpenNewVisit = this.handleOpenNewVisit.bind(this)
    this.handleCloseNewVisit = this.handleCloseNewVisit.bind(this)
    this.handleOpenNewLot = this.handleOpenNewLot.bind(this)
    this.handleCloseNewLot = this.handleCloseNewLot.bind(this)
    this.handleOpenNotificate = this.handleOpenNotificate.bind(this)
    this.handleCloseNotificate = this.handleCloseNotificate.bind(this)
    // this.handleOpenFinishedLot = this.handleOpenFinishedLot.bind(this)
    // this.handleCloseFinishedLot = this.handleCloseFinishedLot.bind(this)
  }

  setModalState (name, flag, e) {
    e && e.preventDefault()
    if ([ 'claim', 'edit' ].indexOf(name) === -1) return
    this.setState(state => ({
      modalState: { ...state.modalState, [name]: flag }
    }))
  }

  handleCloseSigin () {
    this.setState({ isSignin: false })
    this.setState({ registrationLogin: false })
  }

  handleCloseRegion () {
    this.setState({ isRegion: false })
  }

  handleOpenRegion () {
    this.setState({ isRegion: true })
  }

  handleOpenSigin () {
    this.setState({ isSignin: true })
  }

  handleCloseSearch () {
    this.setState({ isSearch: false })
  }

  handleOpenSearch () {
    this.setState({ isSearch: true })
  }

  handleOpenEmailPopup () {
    this.setState({ isEmailPopup: true })
  }
  handleCloseEmailPopup () {
    this.setState({ isEmailPopup: false})
  }

  handleOpenCheckRole() {
    this.setState({ isRolePopup: true})
  }

  handleCloseCheckRole() {
    this.setState({ isRolePopup: false})
  }
  handleOpenEnterPerson() {
    this.setState({isFirstEnterPerson: true})
  }
  handleCloseEnterPerson() {
    this.setState({isFirstEnterPerson: false})
  }
  handleOpenNewVisit() {
    this.setState({isNewVisit: true})
  }
  handleCloseNewVisit() {
    this.setState({isNewVisit: false})
  }
  handleOpenNewLot() {
    this.setState({isNewLot: true})
  }
  handleCloseNewLot() {
    this.setState({isNewLot: false})
  }
  handleOpenNotificate() {
    this.setState({isNotificate: true})
  }
  handleCloseNotificate() {
    this.setState({isNotificate: false})
  }
  // handleOpenFinishedLot() {
  //   this.setState({isFinishedLot: true})
  // }
  // handleCloseFinishedLot() {
  //   this.setState({isFinishedLot: false})
  // }


  handleMenuClose () {
    document.body.classList.add('_animate-menu-close')

    timeout(() => {
      this.setState({ isMenuOpen: false })
      document.body.classList.remove('_animate-menu-close')
    }, 500)

    window.unfreezeBody()
  }

  handleMenuOpen () {
    this.setState({ isMenuOpen: true })
    window.freezeBody()
  }

  handle404 () {
    this.setState({
      container: <NotFound />,
      isIndex: false,
      isLight: true,
      isBottomWhite: false,
      isBottomOrange: true,
      isHalfLight: false
    })
  }

  componentWillMount () {
    this.props.getInitialData()
    if (this.props.isLogged){
      this.props.get()
    }

  }


  componentDidMount () {
    const self = this
    let bodyScrollTop

    // Routing
    // ------------------------------------------------------------------------
    //сейчас весь роутинг идет через функцию getRoutes
    getRoutes(self, PERMISSION);
    // ------------------------------------------------------------------------
    // End Routing

    window.freezeBody = function (isStatic) {
      if (!isStatic) self.setState({ isOverlap: true })

      bodyScrollTop = (typeof window.pageYOffset !== 'undefined') ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
      document.body.style.top = `-${bodyScrollTop}px`
      document.body.classList.add('is-freeze')
    }

    window.unfreezeBody = function (isStatic) {
      if (!isStatic) self.setState({ isOverlap: false })
      timeout(() => {
        document.body.classList.remove('is-freeze')
        document.body.style.top = null
        window.scrollTo(0, bodyScrollTop)
      }, 300)
    }


  }

  componentDidUpdate (prevProps) {
    const prevUserId = prevProps.user && prevProps.user._id
    const nextUserId = this.props.user && this.props.user._id
    const roleChanged = prevProps.role !== this.props.role
    const authChanged = prevProps.isLogged !== this.props.isLogged
    const userChanged = prevUserId !== nextUserId

    if (roleChanged || authChanged || userChanged) {
      const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`
      page.replace(currentPath)
    }
  }

  render () {
    if (this.props.fetching.initial) return null
    
    const { currentCountry, subscribe, subscribed, user, abtest, isLogged, logOut, role, changeRole, get, getLots, getAllVisits, visits } = this.props
    const { modalState } = this.state

    return (
      <div className={classNames('Wrap', {
          '_light': this.state.isLight,
          '_bottomOrange': this.state.isBottomOrange,
          '_bottomWhite': this.state.isBottomWhite,
          '_half-light': this.state.isHalfLight
        })}
        data-vk='424242'
      >
        <Menu
          user={user}
          role={role}
          isLogged={isLogged}
          //
          isOpen={this.state.isMenuOpen}
          handleMenuClose={this.handleMenuClose}
          onOpenSigin={this.handleOpenSigin}
          logOut={logOut}
          onOpenCountrySelect={this.handleOpenRegion}
          openClaim={this.setModalState.bind(this, 'claim', true)}
          openSettings={this.setModalState.bind(this, 'edit', true)}
        />

        {(!this.state.statsPage) && <Header
          user={user}
          role={role}
          abtest={abtest}
          isLogged={isLogged}
          //
          logOut={logOut}
          openClaim={this.setModalState.bind(this, 'claim', true)}
          openSettings={this.setModalState.bind(this, 'edit', true)}
          isIndex={this.state.isIndex}
          isDisable={this.state.isOverlap}
          handleMenuOpen={this.handleMenuOpen}
          onOpenSearch={this.handleOpenSearch}
          onOpenSigin={this.handleOpenSigin}
          onOpenCountrySelect={this.handleOpenRegion}
        />}
        {/*<div style={{position: "relative", zIndex: 99}}>{role}</div>*/}
        <div className={classNames('Background', {
          'Background_full': this.state.isLight || this.state.isBottomOrange,
          'Background_half': this.state.isHalfLight
        })} />

        <div className={classNames('Background_mobile', {
          'Background_mobile_full': this.state.isLight || this.state.isBottomOrange
        })} />

        <div className='Content'>
          <div className='Content__body'>
            {this.state.container}
          </div>
          {(!this.state.statsPage) && <Footer onSubscribe={subscribe} loading={this.props.fetching.subscribe} isSubscribed={subscribed} />}
        </div>

        <div className='Modals'>
          <Overlay isActive={this.state.isSearch} onClose={this.handleCloseSearch}>
            <Search onAfterClick={this.handleCloseSearch} />
          </Overlay>

          <Overlay isActive={this.state.isSignin} onClose={this.handleCloseSigin}>
            <Signin onClose={this.handleCloseSigin} registrationLogin={this.state.registrationLogin}/>
          </Overlay>
          <Overlay isActive={this.state.isRolePopup} onClose={this.handleCloseCheckRole}>
            <ChooseRole changeRole={changeRole} user={user} onClose={this.handleCloseCheckRole}/>
          </Overlay>
          {/*всплывашка с приветственным уведомлением о первом входе в роли персоны*/}
          <Overlay isActive={this.state.isFirstEnterPerson} onClose={this.handleCloseEnterPerson}  klassModifier='welcome-persone mfc-modal_4'>
            <DynamicBanner user={user} onClose={this.handleCloseEnterPerson}/>
          </Overlay>

          <Overlay isActive={this.state.isNewVisit} onClose={this.handleCloseNewVisit}  klassModifier='welcome-persone mfc-modal_4'>
            <DynamicBanner user={user} onClose={this.handleCloseNewVisit} text={"У вас появилась новая встреча"} buttonText={`Смотреть мои встречи`} buttontype={'personvisits'} id={this.state.visitId}/>
          </Overlay>

          <Overlay isActive={this.state.isNewLot} onClose={this.handleCloseNewLot}  klassModifier='welcome-persone mfc-modal_4'>
            <DynamicBanner user={user} onClose={this.handleCloseNewLot} text={"У вас появились новые материалы на согласование"} buttonText={`Смотреть материалы`} buttontype={'lots'} id={this.state.lotId}/>
          </Overlay>

          {/* <Overlay isActive={this.state.isFinishedLot} onClose={this.handleCloseFinishedLot}  klassModifier='welcome-persone mfc-modal_4'>
            <DynamicBanner user={user} onClose={this.handleCloseFinishedLot} text={"Совсем скоро у вас будет новая встреча"} buttonText={`Смотреть материалы`} buttontype={'lots'} id={this.state.finishedLotId}/>
          </Overlay> */}

          <Overlay isActive={this.state.isNotificate} onClose={this.handleCloseNotificate}  klassModifier='welcome-persone mfc-modal_4'>
            <DynamicBanner user={user} onClose={this.handleCloseNotificate} text={`Ваша встреча состоится ${moment(this.state.notificationDate).fromNow()}`} buttonText={`Смотреть мои встречи`} buttontype={'personvisits'} id={this.state.agreedVisitId}/>
          </Overlay>

          <Overlay isActive={modalState.claim} onClose={this.setModalState.bind(this, 'claim', false)} klassModifier={"mfc-modal_3"}>
            <ClaimForm />
          </Overlay>

          <Overlay isActive={modalState.edit} onClose={this.setModalState.bind(this, 'edit', false)}>
            <EditForm />
          </Overlay>

          <Overlay isActive={!currentCountry || this.state.isRegion} onClose={this.handleCloseRegion} klassModifier='is--blured'>
            <Region />
          </Overlay>

          <Overlay isActive={this.state.isEmailPopup} onClose={this.handleCloseEmailPopup} klassModifier='is--blured'>
            <EmailPopup onClose={this.handleCloseEmailPopup}/>
          </Overlay>
        </div>
      </div>
    )
  }

  componentWillReceiveProps(np) {
    //при получении данных пользователя, если у него нет email, предлагаем ввести его
    if ((np.user && (np.user !== this.props.user)) && (!np.user.emails || np.user.emails.length == 0)) {
      let urlParams = window.location.pathname
      let urlPaths = urlParams.split("/")
      if (!urlPaths || urlPaths.length < 1 || (urlPaths[1] != 'checkout' && urlPaths[1] != 'charity'))//не показывать на странице платежа
        this.handleOpenEmailPopup()
    }

    if (!np.isLogged && this.state.registrationLogin) {//для страницы /giftcardssignin - тк нужно отловить момент, когда будут получены данные пользователя
      this.setState({ isSignin: true })
      page.redirect('/giftcard/balance');
    }
    //вывод окна выбора роли
    if (np.user && (np.user !== this.props.user) && np.role === 'user' && (np.user.role === 'user' && (np.user.roles && Object.keys(np.user.roles).length > 0))) {
      this.setState({isRolePopup: true});
    }

    //при входе в систему как персона и наличии новых встреч
    if (!this.state.isViewed_VisitBanner && np.user && (np.role === 'person' && (np.user.person && np.visits["new"]))) {
      for (let visit of np.visits["new"]) {
        if (!visit.isViewed) {
          this.setState((state, props) => ({ isNewVisit: true,  visitId: visit._id, isViewed_VisitBanner: true }))
        }
      }
    }

    //при входе в систему как персона и наличии новых лотов
    if (!this.state.isViewed_LotBanner && np.user && (np.role === 'person' && (np.user.person && np.lots))) {
      for (let lot of np.lots) {
        if (lot.status === "inactive" && (!lot.isViewed)) {
          this.setState((state, props) => ({ isNewLot: true, lotId: lot._id, isViewed_LotBanner: true}))
        }
      }
    }

    // //при входе в систему как персона и наличии завершённых лотов
    // if (!this.state.isViewed_finishedLotBanner && np.user && (np.role === 'person' && (np.user.person && np.lots))) {
    //   for (let lot of np.lots) {
    //     if (lot.status === "complete" && (!lot.isViewed)) {
    //       this.setState((state, props) => ({ isFinishedLot: true, finishedLotId: lot._id, isViewed_finishedLotBanner: true}))
    //     }
    //   }
    // }

    //при входе в систему как персона и наличии назначенных встреч
    if (!this.state.isViewed_NotificationBanner && np.user && (np.role === 'person' && (np.user.person && np.visits["agreed"]))) {
      for (let visit of np.visits["agreed"]) {
        const timeDiff = moment(visit.date).diff(Date.now(), 'hours')
        if(timeDiff >= 4) //&& !visit.isViewed)
          this.setState((state, props) => ({ isNotificate: true, notificationDate: visit.date,  agreedVisitId: visit._id, isViewed_NotificationBanner: true}))
      }
    }
    
    //при первом входе в систему как персона
    if (!this.state.isViewed_WelcomeBanner && np.user  && (np.role === 'person' && (np.user.person && !np.user.person.firstEnter))) {
      this.setState((state, props) => ({isFirstEnterPerson: true, isViewed_WelcomeBanner: true}))
    }

    //запись id пользователя для google tag manager
    if (np.user && (np.user !== this.props.user) && np.user._id){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'userID': np.user._id});  
    }
  }
}

// специальная вставка для того, чтобы перехватить идентификатор страны из адресной строки
// и подставить его как значение по умолчанию
// требуется для корректной обработки чекаут страниц при переходе из мобильного приложения

var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
var trident = ua.indexOf('Trident/');
if (!(trident > 0 || msie>0 )) {
    var urlParams = new URLSearchParams(window.location.search) // eslint-disable-line
    if (urlParams.get('countryId')) {
      window.localStorage.setItem('countryId', urlParams.get('countryId'))
    }
}


// специальная вставка для того, чтобы если невыбран язык и страна подставлять RU по умолчанию
if (!window.localStorage.getItem('countryId')) {
  window.localStorage.setItem('countryId', '59c2647a3a8eb0652ed7a7f0')
  window.localStorage.setItem('locale', 'ru')
}

const mapStateToProps = state => ({
  abtest: abTestInit(),
  isLogged: getIsLogged(state),
  visits: {...state.visitsOfPerson.items},
  lots: { ...state.lots.list.items },
  ...state.persons.info,
  subscribed: state.home.subscribed || null,
  currentLocale: state.intl.locale,
  currentCountry: window.localStorage.getItem('countryId') || null,
  userSettings: getSettingsInfo(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ get, getLots, getAllVisits, logOut, getContacts, subscribe, getCountries, getUserSettings }, dispatch)


const mergeProps = (state, {get, getLots, getAllVisits, ...dispatch}, props) => ({
  ...props,
  ...state,
  logOut: dispatch.logOut,
  subscribe: email => {
    if (!email) return
    if (!validator.validate(email)) return

    return props.fetchingWrap(dispatch.subscribe.bind(this, email), 'subscribe')
  },
  getInitialData: async () => {
    const requests = [
      dispatch.getContacts(),
      dispatch.getCountries()
    ]

    if (state.isLogged) {
      requests.push(dispatch.getUserSettings())
    }

    const getData = () => Promise.all(requests)
    return props.fetchingWrap(getData.bind(this), 'initial')
  },
  get: async (id) => {
    if(!id && !props.user.person) return
    let memberId = id || props.user.person._id;
    let result = await props.fetchingWrap(get.bind(this, memberId), 'info')
    if (result === 200) {
        //получаем список встреч персоны
        await getAllVisits()
        await getLots(memberId)
    }
  }
})

export default fetchingState({ multi: true })(connect(mapStateToProps, mapDispatchToProps, mergeProps)(MainLayout))



// WEBPACK FOOTER //
// ./src/containers/Layout.jsx